// Import model
import { StartProjectAppointmentSendUpcomingAppointmentReminderRequest } from '../models/StartProjectAppointmentSendUpcomingAppointmentReminderRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartProjectAppointmentSendUpcomingAppointmentReminderRequest - handles JSON serialization and deserialization with type validation
 */
export class StartProjectAppointmentSendUpcomingAppointmentReminderRequestSerializer {
  /**
   * Deserializes a JSON string into a StartProjectAppointmentSendUpcomingAppointmentReminderRequest instance
   */
  static deserialize(json: string): StartProjectAppointmentSendUpcomingAppointmentReminderRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartProjectAppointmentSendUpcomingAppointmentReminderRequest instance
   */
  static fromObject(obj: any): StartProjectAppointmentSendUpcomingAppointmentReminderRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartProjectAppointmentSendUpcomingAppointmentReminderRequest');
    }


    const instance: StartProjectAppointmentSendUpcomingAppointmentReminderRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartProjectAppointmentSendUpcomingAppointmentReminderRequest instances
   */
  static deserializeArray(json: string): StartProjectAppointmentSendUpcomingAppointmentReminderRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartProjectAppointmentSendUpcomingAppointmentReminderRequest instance to a JSON string
   */
  static serialize(instance: StartProjectAppointmentSendUpcomingAppointmentReminderRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartProjectAppointmentSendUpcomingAppointmentReminderRequest instance to a plain object
   */
  static toObject(instance: StartProjectAppointmentSendUpcomingAppointmentReminderRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartProjectAppointmentSendUpcomingAppointmentReminderRequest instances to a JSON string
   */
  static serializeArray(instances: StartProjectAppointmentSendUpcomingAppointmentReminderRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
